import MovieCard from '@/components/base/MovieCard';
import { movies } from '@/mocks/movies';

const newMovies = movies.filter((m) => m.isNew);

export default function NewReleases() {
  return (
    <section className="py-12 md:py-16">
      <div className="container-site">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            最新上线
          </h2>
          <p className="text-sm text-foreground-500 mt-1">刚刚更新的热门影片，快来看看吧</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {newMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}